var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.latestNotifications),function(latestNotification){return _c('latest-notification',{key:latestNotification.id,attrs:{"latest-notification":latestNotification,"view-route":_vm.baseRoute + '/' + latestNotification.id,"mark-as-read-string":_vm.markAsReadString,"read-notifications":_vm.readNotifications}})}),1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5311c8f9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/admin-panel/components/widgets/latestNotifications.vue
// module id = tiAy
// module chunks = 0